export default {
  methods: {
    getPaymentGatewayById(type) {
      if (type) {
        // use regex to get value inside "paymentgateway(" and ")"

        const paymentId = type.match(/paymentgateway\(([^)]+)\)/)
        if (paymentId) {
          const paymentType = this.$store.state.paymentGateways.find(
            (payment) => payment.id === paymentId[1]
          )
          return paymentType || null
        } else {
          return null
        }
      } else {
        return null
      }
    }
  }
}
